// src/components/resources/tools/generators/AdMockup/ad-format.ts
//
// Framework-free pure helpers for the Ad Mockup generator: engagement-count
// abbreviation, avatar initials, and the Instagram-style handle derivation.
// Extracted verbatim from the former single-file component so they can be
// unit-tested in isolation.

export function formatCount(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, '')}K`
  return String(n)
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  const first = parts[0] ?? ''
  if (!first) return '?'
  if (parts.length === 1) return first.slice(0, 2).toUpperCase()
  const last = parts[parts.length - 1] ?? first
  return (first.charAt(0) + last.charAt(0)).toUpperCase()
}

/** Derive an Instagram-style handle: lowercase, ASCII handle charset only. */
export function handleOf(name: string): string {
  const handle = name.toLowerCase().replace(/[^a-z0-9._]/g, '')
  return handle || 'yourbrand'
}
